/* eslint-disable no-case-declarations */
import Devices from '../../services/devices';
import { LoginState } from '../../store/login/types';

const communicationMethodLocation = (element: any) => element?.communicationMethod === 'Cellular'  || element?.communicationMethod === 'Satellite'

export const isTetheredRadio = (selectedDevice: any) => {
  if(selectedDevice?.data?.device?.radioComponents?.find(communicationMethodLocation)) return false
  if(selectedDevice?.data?.device?.radios && selectedDevice?.data?.device?.radios[0]?.radioComponents?.find(communicationMethodLocation)) return true;
  return false;
}

export const updateDevice = async ({
    login,
    selectedDevice,
    patchDetails,
  }: {
    login: LoginState;
    selectedDevice: any;
    patchDetails:any
  }) => {
    const {
        client,
        envVariables: { deviceApiV2BaseUrl },
    } = login;
    const devices = new Devices(client, deviceApiV2BaseUrl);
    if(selectedDevice.data?.device?.deviceKey)  {
        const radioData: any = [];
        const {device, ...tetheredPatchDetails} = patchDetails;
        const deviceKey = selectedDevice.data?.device?.deviceKey;
        if((patchDetails.cellRadio || patchDetails.satRadio) && isTetheredRadio(selectedDevice)) {
            switch(selectedDevice.data.device.radios.length) {
                case 1:
                    const deviceResponse = await devices.updateDeviceRadio(selectedDevice.data.device.radios[0].deviceKey, tetheredPatchDetails);
                    radioData.push(deviceResponse?.data?.device);
                    break;
                case 2:
                    const {cellRadio, satRadio} = tetheredPatchDetails;
                    const cellDeviceResponse = await devices.updateDeviceRadio(selectedDevice.data.device.radios.find((radio: any) => radio.radioComponents[0].communicationMethod === 'Cellular').deviceKey, {cellRadio});
                    radioData.push(cellDeviceResponse?.data?.device)
                    const satDeviceResponse = await devices.updateDeviceRadio(selectedDevice.data.device.radios.find((radio: any) => radio.radioComponents[0].communicationMethod === 'Satellite').deviceKey, {satRadio});
                    radioData.push(satDeviceResponse?.data?.device)
                    break;
                default:
            }

        }
        let response: any = null;
        if(device || !isTetheredRadio(selectedDevice)) response = await (isTetheredRadio(selectedDevice) ? devices.updateDeviceRadio(deviceKey, {device}): devices.updateDeviceRadio(deviceKey, patchDetails));
        const updatedDevice = JSON.parse(JSON.stringify(selectedDevice));
        if(updatedDevice?.data?.device) {
            if(response?.data?.device) {
                updatedDevice.data.device.lastUpdatedBy = response.data.device.lastUpdatedBy;
                updatedDevice.data.device.updatedTime = response.data.device.updatedTime;
                if(patchDetails?.device  ) {
                    updatedDevice.data.device.deviceStatus = response.data.device?.deviceStatus;
                    updatedDevice.data.device.isSwapsEnabled = response.data.device?.isSwapsEnabled;
                    updatedDevice.data.device.isRadioDropEnabled = response.data.device?.isRadioDropEnabled;
                }
            }
            if(Object.keys(radioData).length > 0) {
                updatedDevice.data.device.radios = radioData;
            }
            else if ((patchDetails.cellRadio || patchDetails.satRadio) && response?.data?.device?.radioComponents) {
                updatedDevice.data.device.radioComponents = response.data.device.radioComponents;
                updatedDevice.data.device.radioComponents[0].CDMAPreferred = response.data.device.radioComponents[0]?.CDMAPreferred;
            }
            return updatedDevice;
        }
    }
    return null;
};
